export default "__VITE_ASSET__CwFBaFpz__"